import { type FileType } from 'components/DynamicDownload/interfaces';

export const extractNameAndTypeFromUrl = (url: string) => {
  const parsedURL = new URL(url);
  const name = parsedURL.pathname.split('/').pop() || '';
  const type = (name.split('.').pop() || '') as FileType;
  return { name, type };
};
